/*
 * loading Actions
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 04-Sep-2024
 */

import { createAction } from './index'

export const actionTypes = {
  DO_LOCAL_LOADING: '@@loading/local_loading'
  // @generator action:type
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request
// @generator action
/** @action
* * Insert a description
* @name LocalLoading
* @return {object} - The payload object
*/
export const doLocalLoading = payload => createAction(actionTypes.DO_LOCAL_LOADING, { payload })
